define('modules/file_upload/upload_item_view',[
  'backbone',
  'jquery',
  '_',

  'text!./upload_item_template.html'
], function (Backbone, $, _,
             upload_item_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.listenTo(this.model, 'change:uploading', function () {
        if (this.model.get('uploading') === true) {
          this.render();
        } else {
          this.remove();
        }
      }, this);

      this.listenTo(this.model, 'change:progress', function () {
        this.showProgress();
      });

      this.listenTo(this.model, 'change:remove', function () {
        this.remove();
      }, this);

      this.render();
    },

    subViews: [],
    tagName: 'li',
    className: 'list-item',
    template: _.template(upload_item_template),

    events: {},

    render: function () {
      this.$el.html(this.template(this.model.toJSON()));
      return this;
    },

    showProgress: function () {
      this.$('.file-upload-progress span').css('width', this.model.get('progress') + '%');
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.remove();
      this.stopListening();
      return this;
    }

  });
  return View;
});

